import React from 'react'
import { Anchor, Box } from 'grommet'
import styled from 'styled-components'

const TocBox = styled(Box)`
  display: block;
  background-color: ${props => props.theme.global.colors.sectionBg};
  border: 1px solid ${props => props.theme.global.colors.border};
  padding: 1rem 3rem;
  border-radius: 0.5rem;
  margin-top: 1rem;
  margin-bottom: -1rem;
  min-width: 35rem;

  @media (max-width: 420px) {
    min-width: 32rem;
  }

  #TableOfContent {
    margin-top: 1.2rem;
    margin-left: 3.5rem;
    margin-bottom: 1rem;
    color: ${props => props.theme.global.colors.text};
    display: none;
  }
  #tocCheckbox:checked + * + #TableOfContent {
    display: block;
  }

  & > label {
    /* margin-left: 10rem; */
    font-size: 1.6rem;
    float: right;
    user-select: none;
    &:hover {
      text-decoration: underline;
    }
  }
`

const TableOfContent = ({ menu, title = 'Table of Contents' }) => {
  return (
    <TocBox alignSelf="start">
      <span style={{ display: 'inline-block' }}>
        <strong>{title}</strong>
      </span>
      <input type="checkbox" id="tocCheckbox" style={{ display: 'none' }} />
      <label for="tocCheckbox" style={{ display: 'inline-block' }}>
        Show/Hide
      </label>

      <ol id="TableOfContent">
        {menu.map(item => {
          let id = item
          id = id.replace(/\s+/g, '-').toLowerCase()
          return (
            <li key={id}>
              <Anchor color="text" weight={400} href={`#${id}`}>
                {item}
              </Anchor>
            </li>
          )
        })}
      </ol>
    </TocBox>
  )
}

export default TableOfContent
